import { createFileRoute, redirect } from "@tanstack/react-router";
import { RevistaStarContent, STAR_FAQ } from "@/components/funis/RevistaStarContent";

const CHECKOUT_URL_DEFAULT = "https://chk.eduzz.com/2307931?df=1&pf=1&utm_source=revista";

export const Route = createFileRoute("/revista-star")({
  beforeLoad: ({ location }) => { throw redirect({ href: `/star${new URL(location.href, "https://fisioemortopedia.com.br").search}`, statusCode: 301 }); },
  head: () => ({
    meta: [
      { title: "Suas revistas foram enviadas! · Cupom Star Cursos R$77 | FEO" },
      { name: "description", content: "As suas revistas já estão disponíveis no seu e-mail. Aproveite: cupom exclusivo para acessar a Star Cursos por apenas R$77 no primeiro ano." },
      { property: "og:title", content: "Suas revistas foram enviadas!" },
      { property: "og:description", content: "Cupom exclusivo Star Cursos, R$77 no primeiro ano." },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex,nofollow" },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: STAR_FAQ.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
    ],
  }),
  component: () => <RevistaStarContent defaultCheckoutUrl={CHECKOUT_URL_DEFAULT} />,
});
